// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import './WizardProgressBar.css';

interface WizardProgressBarProps {
  currentStepIndex: number;
  totalSteps: number;
  currentStepName: string;
  onExpandSidebar: () => void;
}

export function WizardProgressBar({
  currentStepIndex,
  totalSteps,
  currentStepName,
  onExpandSidebar,
}: WizardProgressBarProps) {
  const progressPercent = ((currentStepIndex + 1) / totalSteps) * 100;

  return (
    <div
      className="wizard-progress-bar"
      role="progressbar"
      aria-valuenow={currentStepIndex + 1}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label="Form progress"
    >
      <div className="wizard-progress-bar__info">
        <span className="wizard-progress-bar__text">
          Step {currentStepIndex + 1} of {totalSteps}: {currentStepName}
        </span>
        <button
          className="wizard-progress-bar__menu"
          onClick={onExpandSidebar}
          aria-label="Open step navigation"
          type="button"
        >
          <span>{'\u2630'}</span>
        </button>
      </div>
      <div className="wizard-progress-bar__track">
        <div
          className="wizard-progress-bar__fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}
